function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "battery_charging"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m16 5h-8c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2v-13c0-1.103-.897-2-2-2zm-.003 15h-7.997v-13h8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11 4h2c.552 0 1-.447 1-1s-.448-1-1-1h-2c-.552 0-1 .447-1 1s.448 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 14.5h2.382l-1.276 2.553c-.247.494-.047 1.095.447 1.342.144.071.296.105.446.105.367 0 .72-.202.896-.553l2-4c.155-.31.138-.678-.044-.973s-.504-.474-.851-.474h-2.382l1.276-2.553c.247-.494.047-1.095-.447-1.342-.495-.246-1.095-.047-1.342.447l-2 4c-.155.31-.138.678.044.973s.504.475.851.475z"
})));

var Svg002Batterycharge = function Svg002Batterycharge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg002Batterycharge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/002-battery charge.298604c2.svg";
export { ForwardRef as ReactComponent };